import React from 'react';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { IInventoryItem } from 'gen/ApiClient';
import { SelectableColumn } from '../SelectableColumn';

interface IViewContext extends ITableViewContext<SelectableColumn, IInventoryItem> {}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
